import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
// import { TextMaskModule } from 'angular2-text-mask';

// import { ShareModule } from '../../../utilDirective/share.module';
import { CalendarComponent } from './calendar.component';
import { FormatJPDate, FormatJPDateEra, JPStringDateCalender, SelectedDay } from './calendar.model';
import { ChooseDateComponent } from './choose-date/choose-date/choose-date.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { MaterialModule } from '@core/material';

@NgModule({
  declarations: [
    DatepickerComponent,
    FormatJPDate,
    FormatJPDateEra,
    SelectedDay,
    JPStringDateCalender,
    CalendarComponent,
    ChooseDateComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    // TextMaskModule,
    TranslateModule,
    // ShareModule
  ],
  exports: [
    DatepickerComponent,
    ChooseDateComponent,
    FormatJPDate,
    FormatJPDateEra,
    SelectedDay,
    JPStringDateCalender,
    // ShareModule,
  ],
  providers: [],
})
export class CalendarModule { }
